export const glassBeforeCompile = (shader: any) => {
  const alphaMatcap = ` 
        diffuseColor.a =  texture2D( matcap, uv ).b + texture2D( matcap, uv ).g + texture2D( matcap, uv ).r * 1.0;
        gl_FragColor = vec4( outgoingLight, diffuseColor.a * opacity );
        `;

  shader.fragmentShader = shader.fragmentShader.replace('#include <opaque_fragment>', alphaMatcap);
};
